// extracted by mini-css-extract-plugin
export default {"bodyCards":"style_bodyCards__QdBhq","card":"style_card__uZO--","image":"style_image__P6xwr","label":"style_label__atMlX","selected":"style_selected__mEPT7"};